import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import uiControll from '@/store/uiControll'
import getCsrfToken from '@/store/Csrf'
import { commonUtil } from '@/util'
import setUserAuthority from './request/setUserAuthority'
import setUserInvite from './request/setUserInvite'
import registerUserInfo from './request/registerUserInfo'
import registerOrganization from './request/registerOrganization'
import setPasswordAfterInvite from './request/setPasswordAfterInvite'
import setTutorialStatus from './request/setTutorialStatus'

const Actions = {
  // UR03 ユーザー新規登録
  registerUser: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_REGISTER, params)
      .post(api.USER_REGISTER, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // UR05 ユーザー姓名、組織登録
  registerUserProfile: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_PROFILE, params)
      .patch(api.USER_PROFILE, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UM02 ユーザー情報取得
  getUserInfoFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      .get(api.USER_INFO)
      // .get(apiMock.USER_INFO)
      .then((response) => {
        const getData = response.data.data
        commit(mutationsTypes.USER_SET_USER_INFO, getData)
        commit(mutationsTypes.USER_SET_UNREAD_NOTICE_COUNT, getData.noticeRead)
        commonUtil.hasRegisteredUserInfo(response.data, true)
        return commonUtil.afterApiSuccessProcess(response, getData)
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        // commonErrorControl(error.response)
        return false
      })
  },
  // UM03 ユーザー情報一覧取得
  getUserListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    return await axios
      .get(api.USER_LIST)
      // .get(apiMock.USER_LIST)
      .then((response) => {
        const path = mutationsTypes.USER_SET_USER_LIST
        commit(path, response.data.data)
        const getData = getters.getUserListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        // commonErrorControl(error.response)
        return false
      })
  },
  // UM01 所属ユーザーの権限設定
  setUserAuthority: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = setUserAuthority.request.createRequest(params)
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_AUTHORITY_SETTING)
      .patch(api.USER_AUTHORITY_SETTING, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR02 ユーザー招待
  inviteUser: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = setUserInvite.request.createRequest(params)

    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_INVITE)
      .post(api.USER_INVITE, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR04 ユーザー情報登録
  registerUserPrivateInfo: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = registerUserInfo.request.createRequest(params)

    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_PRIVATEINFO)
      .patch(api.USER_PRIVATEINFO, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR01 組織情報登録
  registerOrganization: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = registerOrganization.request.createRequest(params)

    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_ORGANIZATION)
      .patch(api.USER_ORGANIZATION, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR06 パスワード再設定用メール送信
  sendMailForResetPassword: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_FORGOT_PASSWORD)
      .post(api.USER_FORGOT_PASSWORD, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR07 パスワード再設定
  resetPassword: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_RESET_PASSWORD)
      .post(api.USER_RESET_PASSWORD, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR11 パスワード変更
  changePassword: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_RESET_PASSWORD)
      .post(api.USER_CHANGE_PASSWORD, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR09 メールアドレス変更
  changeMailAddress: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_CHANGE_MAILADDRESS)
      .put(api.USER_CHANGE_MAILADDRESS, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // AL01 使用期限アラート既読
  patchProductExpiredDateAlertRead: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .patch(`${api.PRODUCT_EXPIRED_DATE_ALERT_READ}/${params.id}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // AL02 使用期限アラート未読一覧取得
  getProductExpiredDateAlertUnreadsFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .get(api.PRODUCT_EXPIRED_DATE_ALERT_UNREADS)
      // .get(apiMock.PRODUCT_EXPIRED_DATE_ALERT_UNREADS)
      .then((response) => {
        // const productExpiredDateAlertList = response.data
        const { productExpiredDateAlertList } = response.data.data
        const path = mutationsTypes.PRODUCT_EXPIRED_DATE_ALERT_UNREADS
        commit(path, productExpiredDateAlertList)
        return commonUtil.afterApiSuccessProcess(
          response,
          productExpiredDateAlertList
        )
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
  },
  // UR10 締め日設定
  setClosingDate: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_CLOSING_DATE)
      .patch(api.USER_CLOSING_DATE, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR08 招待後パスワード再設定
  setPasswordAfterInvite: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = setPasswordAfterInvite.request.createRequest(params)
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_SET_PASSWORD_AFTER_INVITE)
      .post(api.USER_SET_PASSWORD_AFTER_INVITE, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UM04 退会
  userLeave: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_LEAVE)
      .patch(`${api.USER_LEAVE}/${params.userId}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UR12 組織退会
  organizationWithdraw: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_LEAVE)
      .patch(`${api.ORGANIZATION_WITHDRAW}/${params.userId}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UM01 所属ユーザーの権限設定
  userAuthority: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_AUTHORITY)
      .patch(api.USER_AUTHORITY, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UM05 お知らせ既読
  async userNoticeRead({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) {
    await getCsrfToken()
    const ret = await axios
      // .get(apiMock.USER_NOTICE_READ)
      .patch(api.USER_NOTICE_READ)
      .then((response) => {
        commit(mutationsTypes.USER_SET_UNREAD_NOTICE_COUNT, 0)
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  // UM06 チュートリアル進行
  setTutorialStatus: async ({ commit }, params) => {
    const req = setTutorialStatus.request.createRequest(params.status)
    await getCsrfToken()
    const ret = await axios
      .patch(api.USER_SET_TUTORIAL_STATUS, req)
      .then(() => {
        commit(mutationsTypes.USER_SET_TUTORIAL_STATUS, params.status)
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
    return ret
  },
  setUserInfo: ({ commit }, param) => {
    commit(mutationsTypes.USER_SET_USER_INFO, param)
  }
}

export default Actions
